import { AtrTrailLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/AtrTrailLine';
import { AtrTrailTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/exits/AtrTrailTacticPanel';
import { AddAtrTrailTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddAtrTrailTacticPanel';
import { AtrTrailWrapper } from '../../../../components/displays/tradeplans/softOrderModules/exitTacticModules/AtrTrailModule/AtrTrailWrapper';
import { ATRTrailDocumentation } from '../../../../components/forms/tradeplans/documentation/ATRTrailDocumentation';
import { AtrTrailModule } from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/modules/AtrTrailModule';
import { AtrTrailData } from './atrTrailData';
import { validateAtrTrail } from './validateAtrTrail';

export const AtrTrail = {
  //data class
  dataStore: AtrTrailData,

  //string constants
  name: 'ATR_TRAIL',
  tacticLabel: 'ATR Trail',
  addTacticLabel: 'Add ATR Trail',
  category: 'Exit',

  // components
  tradePlanFormModule: AtrTrailModule,
  tacticPanel: AtrTrailTacticPanel,
  addTacticPanel: AddAtrTrailTacticPanel,
  wrapper: AtrTrailWrapper,
  chartSoftOrderComponent: AtrTrailLine,
  documentation: ATRTrailDocumentation,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null,
  validationFunction: validateAtrTrail,
};
